import { unstable_setRef as setRef } from '@material-ui/utils';
export default setRef;